import { axiosV1 } from 'interceptors/axios';
import { Dispatch } from 'redux';

import { ApiQueryParams } from 'types';

import { decryptResponse } from 'utils/token';
import { dispatchError } from 'utils/dispatchError';

type GetHoldingClassesProps = {
  societyId: string;
  partnerId?: string;
  params?: ApiQueryParams;
  includeRanges?: boolean;
  signal?: AbortSignal;
};

export const getHoldingClasses =
  ({
    societyId,
    partnerId,
    params = {},
    includeRanges = false,
    signal,
  }: GetHoldingClassesProps) =>
  async (dispatch: Dispatch) => {
    try {
      const { data } = await axiosV1.get(`/holdingClasses`, {
        params: {
          societyId,
          partnerId,
          includeRanges,
          ...params,
        },
        // signal,
      });

      const decodedData = await decryptResponse(data);

      return decodedData;
    } catch (error) {
      return dispatchError(error, dispatch);
    }
  };
